import { useDialog } from '@dni-hooks/useDialog'
import { Button } from '@pets-ui/Button/Button'
import { Dialog } from '@pets-ui/Dialog/Dialog'
import { DialogActions } from '@pets-ui/DialogActions/DialogActions'
import { DialogContent } from '@pets-ui/DialogContent/DialogContent'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { Text } from '@pets-ui/Text/Text'
import { type ReactNode } from 'react'

export const DIALOG_REDIRECT_CONFIRM = 'DialogRedirectConfirm'

export interface DialogRedirectConfirmProps {
  title: ReactNode
  description: ReactNode
  confirmText: ReactNode
  cancelText: ReactNode
  onConfirm: () => void
  onCancel: () => void
}

export const DialogRedirectConfirm = () => {
  const { open, onCancel, onConfirm, title, description, confirmText, cancelText } = useDialog<DialogRedirectConfirmProps>(DIALOG_REDIRECT_CONFIRM)

  return (
    <Dialog open={open} fullWidth maxWidth={320}>
      <DialogHeader title={title} />
      <DialogContent>
        <Text>{description}</Text>
      </DialogContent>
      <DialogActions justifyContent="center">
        <Button fullWidth variant="outlined" onClick={onCancel}>{cancelText}</Button>
        <Button fullWidth onClick={onConfirm}>{confirmText}</Button>
      </DialogActions>
    </Dialog>
  )
}
